module.exports = __webpack_public_path__ + "img/5.661e0dfa.jpg";